import {
  PREPAID_BY_PRODUCT,
  PREPAID_BY_PRODUCT_ERROR,
  CLEAN_PREPAID_BY_PRODUCT,
  CLEAN_PREPAID_BY_PRODUCT_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function prepaidByProductReducer(state = initialState, action) {
  switch (action.type) {
    case PREPAID_BY_PRODUCT:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case PREPAID_BY_PRODUCT_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_PREPAID_BY_PRODUCT:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_PREPAID_BY_PRODUCT_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
